export default __webpack_public_path__ + "static/control-6118523e1f41f08b5fac74b2e8f20e98.png";